import { ApiResult } from '@models/api';
import { fetcherMutation } from 'utils/react-query';
import { useMutation, UseMutationOptions } from '@hooks/react-query';

import { VerifyPinParams } from '../models/mutations';

function useRVerifyPin(
  options: UseMutationOptions<
    ApiResult<unknown>,
    Record<string, unknown>,
    VerifyPinParams
  > = {},
) {
  return useMutation<
    ApiResult<unknown>,
    Record<string, unknown>,
    VerifyPinParams
  >({
    mutationFn: async ({ context, variables }) =>
      await fetcherMutation({
        context: {
          ...context,
          method: 'POST',
          path: 'v2/verify-pin',
        },
        variables,
      }),
    ...options,
  });
}

export default useRVerifyPin;
